export default __webpack_public_path__ + "static/media/zoom.02d150c6.svg";